import {useQuery} from 'react-query';
import RefreshCheckApi from '../../../../communication_system/axios_apis/refresh_check/refresh_check_api';

/**managements overview data */
export const useManagementsOverview = () => {
    return useQuery({
        queryKey: ['managements-overview'],
        queryFn: async () => {
            const response = await RefreshCheckApi.get('/v2/dashboard/count');
            if (!response.data.ok) {
                throw new Error('Network response was not ok');
            }

            return response.data.data;
        },
        staleTime: 5 * 60 * 1000,
        cacheTime: 60 * 60 * 1000,
    });
};
